module.exports = __webpack_public_path__ + "static/media/ProductWeb.1df40556.webp";